<div class="form-field">
  <label [for]="id">{{ label }}</label>
  <div class="input-content" [class.with-success-icon]="showSuccessIcon">
    <input
      matInput
      [class.invalid]="!!error"
      [id]="id"
      [name]="id"
      [placeholder]="placeholder ?? ''"
      [(ngModel)]="inputValue"
      (ngModelChange)="onInputChange($event)"
      [ngModelOptions]="{ standalone: true }"
      (focus)="emitFocus()"
      (focusout)="emitFocusOut()"
      mask="d0/M0/0000"
      [dropSpecialCharacters]="false"
      [disabled]="disabled"
      [style.cursor]="disabled ? 'not-allowed' : 'default'"
    />

    <input
      matInput
      [matDatepicker]="picker"
      [(ngModel)]="value"
      (dateChange)="onPickerChange($event)"
      [ngModelOptions]="{ standalone: true }"
      style="width: 0; height: 0; opacity: 0; position: absolute; pointer-events: none;"
      tabindex="-1"
      [disabled]="disabled"
    />

    <!-- <button
      mat-icon-button
      class="password-visibility"
      (click)="visibleValue = !visibleValue"
    >
      <mat-icon>{{  }}</mat-icon>
    </button> -->
    <mat-datepicker-toggle
      class="btn-date-toogle"
      matIconSuffix
      [for]="picker"
      [disabled]="disabled"
    ></mat-datepicker-toggle>
    <div *ngIf="showSuccessIcon" class="success-icon" matSuffix>
      <mat-icon>check</mat-icon>
    </div>
    <mat-datepicker #picker [disabled]="disabled"></mat-datepicker>
  </div>
  <p class="hint-error" *ngIf="error">{{ error }}</p>
</div>
